module.exports = __webpack_public_path__ + "static/media/alerta-documentacion-auto-verde.a29cb348.svg";